// Types
import { EListingStatus } from '~/misc/listings/types';
import { EFeatureName } from '~/misc/feature/types';
import type { TFeatureOpportunityStatsConfig } from '~/shared/stats/types';

/*
 * These statuses relevant not only for stats but for app in general.
 * TODO: revise to find a proper place.
 */
const ON_MARKET_STATUSES: EListingStatus[] = [
  EListingStatus.NEW_ON_MARKET,
  EListingStatus.REDUCED,
  EListingStatus.OVER_2_WEEKS,
  EListingStatus.OVER_8_WEEKS,
  EListingStatus.OVER_12_WEEKS,
  EListingStatus.OVER_16_WEEKS,
];

const NEW_MARKET_STATUSES: EListingStatus[] = [
  EListingStatus.UNDER_OFFER_AND_SSTC,
  EListingStatus.RECENTLY_SOLD,
  EListingStatus.NEW,
  EListingStatus.LET_AGREED,
];

const ANNIVERSARY_STATUSES: EListingStatus[] = [
  EListingStatus.ANNIVERSARY_1_YEAR,
  EListingStatus.ANNIVERSARY_2_YEARS,
  EListingStatus.ANNIVERSARY_3_YEARS,
  EListingStatus.ANNIVERSARY_5_YEARS,
  EListingStatus.ANNIVERSARY_7_YEARS,
  EListingStatus.ANNIVERSARY_OVER_10_YEARS,
];

const FEATURE_OPPORTUNITY_STATS_CONFIG: TFeatureOpportunityStatsConfig[] = [
  {
    title: 'On-market',
    lookupCategories: ON_MARKET_STATUSES,
  },
  {
    title: 'Market Success',
    lookupCategories: NEW_MARKET_STATUSES,
  },
  {
    title: 'Anniversary',
    lookupCategories: ANNIVERSARY_STATUSES,
    protectedFeature: EFeatureName.OPPORTUNITY_SEARCH_ANNIVERSARY,
  },
  {
    title: 'Withdrawn',
    lookupCategories: ['withdrawn'],
    protectedFeature: EFeatureName.OPPORTUNITY_SEARCH_WITHDRAWN,
  },
  {
    title: 'Likely Sold',
    lookupCategories: ['likely-sold'],
    protectedFeature: EFeatureName.OPPORTUNITY_SEARCH_LIKELY_SOLD,
  },
];

export {
  ON_MARKET_STATUSES,
  NEW_MARKET_STATUSES,
  ANNIVERSARY_STATUSES,
  FEATURE_OPPORTUNITY_STATS_CONFIG,
};
